import React, { Component, createRef } from 'react';
import { injectIntl } from 'react-intl';

import classes from './styles.module.css';

class LanguageSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpened: false,
        };

        this.toggleState = this.toggleState.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.langWrap = createRef();
        this.langSelect = createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, false);
    }

    componentDidUpdate(_prevProps, _prevState, _snapshot) {
        document.addEventListener('click', this.handleClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, false);
    }

    handleClickOutside = (e) => {
        if (!this.langSelect.current || !this.langWrap.current.contains(e.target)) {
            this.setState({
                isOpened: false,
            });
        }
    };

    toggleState() {
        this.setState({ isOpened: !this.state.isOpened });
    }

    render() {
        const { intl } = this.props;
        let currentLanguage;
        let langClass;

        switch (this.props.lang) {
            case 'ru':
                currentLanguage = intl.formatMessage({ id: 'LanguageSelect.language.ru', defaultMessage: 'Русский' });
                langClass = classes.Ru;
                break;
            case 'en':
                currentLanguage = intl.formatMessage({ id: 'LanguageSelect.language.en', defaultMessage: 'English' });
                langClass = classes.En;
                break;
            default:
                currentLanguage = intl.formatMessage({ id: 'LanguageSelect.language.en', defaultMessage: 'English' });
                langClass = classes.En;
        }

        return (
            <div ref={this.langWrap} className={classes.Lang}>
                <div onClick={this.toggleState} className={`${classes.Current} ${langClass}`}>
                    {currentLanguage}
                </div>

                {this.state.isOpened && (
                    <div ref={this.langSelect} className={classes.Select}>
                        <div
                            onClick={() => {
                                this.props.onChangeLanguage('ru');
                                this.toggleState();
                            }}
                            className={`${classes.Element} ${classes.Ru}`}
                        >
                            {intl.formatMessage({ id: 'LanguageSelect.language.ru', defaultMessage: 'Русский' })}
                        </div>
                        <div
                            onClick={() => {
                                this.props.onChangeLanguage('en');
                                this.toggleState();
                            }}
                            className={`${classes.Element} ${classes.En}`}
                        >
                            {intl.formatMessage({ id: 'LanguageSelect.language.en', defaultMessage: 'English' })}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default injectIntl(LanguageSelect);



// WEBPACK FOOTER //
// ./src/Components/LanguageSelect/index.js